/**
 * Cola de sincronización offline — basada en localStorage
 * Síncrona, sin inicialización, nunca falla.
 * IndexedDB es demasiado frágil para operaciones críticas como el fichaje.
 */

const KEY = 'sgv_queue';

export function getQueue() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
}

export function addToQueue(method, url, data) {
  try {
    const q = getQueue();
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
    q.push({ id, method, url, data, ts: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(q));
    return id;
  } catch { return null; }
}

export function removeFromQueue(id) {
  try {
    localStorage.setItem(KEY, JSON.stringify(getQueue().filter(i => i.id !== id)));
  } catch {}
}

export function queueSize() {
  return getQueue().length;
}
